import * as React from "react";
import Box from "@mui/material/Box";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";

type ItemRow = LTLState["items"][number];

interface LtlFreightItemNmfcDescriptionRowProps {
  item: ItemRow;
  index: number;
  state: LTLState;
  showNmfc: boolean;
  nmfcRequired: boolean;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
}

export function LtlFreightItemNmfcDescriptionRow({
  item,
  index,
  state,
  showNmfc,
  nmfcRequired,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
}: LtlFreightItemNmfcDescriptionRowProps): React.ReactElement {
  const st = (suffix: string) => getTextFieldStyles(`item${index}_${suffix}`) as ITextFieldStyles;

  return (
    <Box sx={styles.row}>
      {showNmfc && (
        <Box sx={styles.fieldGroup}>
          <TextField
            label="NMFC"
            value={item.nmfc || ""}
            required={nmfcRequired}
            id={ltlFieldInputId(`item${index}_nmfc`)}
            styles={st("nmfc")}
            errorMessage={state.errors[`item${index}_nmfc`]}
            onChange={(e, newValue) => onItemFieldChange(index, "nmfc", newValue || "")}
            onBlur={onFieldBlur}
          />
        </Box>
      )}
      <Box sx={showNmfc ? styles.fieldGroupWide : styles.fieldGroupWideAlone}>
        <TextField
          label="Product Description"
          value={item.productDescription || ""}
          id={ltlFieldInputId(`item${index}_description`)}
          styles={st("description")}
          onChange={(e, newValue) => onItemFieldChange(index, "productDescription", newValue || "")}
          onBlur={onFieldBlur}
        />
      </Box>
    </Box>
  );
}
